/**
 * Deze klasse handelt het toevoegen of aanpassen van een location af
 *
 * @history
 * 3 augustus 2023
 * controle afbeelding
 *
 * 25 november 2022
 * tonen van eventuele afbeelding bij edit
 *
 * 17 november 2022
 * image afhandeling
 *
 * 7 november 2022
 * Start implementatie
 *
 */

import React from "react";
import {Popup} from "../../containers/Popup";
import {LocationLibSelector} from "../../helpers/LocationLibSelector";
import {FormPopup} from "../../containers/FormPopup";

export class LocationForm extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                show_err: false,
                err_message: "",
                image_lib_visible:false,
                def_location_image_id : 0,
                image_oke: true,

            }

        this.inputTitle = React.createRef();
        this.inputImageBtn = React.createRef();
        this.deleteImgBtn = React.createRef();
        this.imagePreview = React.createRef();

        this.storeClicked = this.storeClicked.bind(this);
        this.terugClicked = this.terugClicked.bind(this);
        this.imageSelectClicked = this.imageSelectClicked.bind(this);
        this.imageDeleteClicked = this.imageDeleteClicked.bind(this);
        this.imageSelected = this.imageSelected.bind(this);
        this.showImageLibClicked = this.showImageLibClicked.bind(this);
        this.selectImageLib = this.selectImageLib.bind(this);

        this.formData = new FormData();

        this.image_data = "";
        this.delete_image_upload = false; // als er geen image_data aanwezig is wordt de has_image='N' gestuurd zodat php een bestaande afbeelding kan verwijderen (store_location)


        if (this.props.action == "add") {
            this.props.record =
                {
                    title: "",
                    has_image:"N",
                    def_location_image_id:0
                };

            this.form_url = "/add_location";

        } else {
            this.form_url = "/store_location";
            this.formData.append("location_id", this.props.record.id);
            this.state.def_location_image_id = this.props.record.def_location_image_id;
        }
    }

    imageSelectClicked() {
        this.inputImageBtn.current.click();
    }

    imageDeleteClicked() {

        this.deleteImgBtn.current.style.display = 'none';
        this.imagePreview.current.style.display = 'none';
        this.image_data = "";
        this.delete_image_upload = true;
        this.setState({ image_oke:true});
        this.setState({ def_location_image_id:0});
    }

    showImageLibClicked()
    {
        this.setState({image_lib_visible:true});
    }

    selectImageLib(p_id,p_image_url)
    {
        if (p_id > 0)
        {
            // er is een keuze gemaakt
            this.deleteImgBtn.current.style.display = 'inline-block';
            this.imagePreview.current.style.display = 'block';
            this.imagePreview.current.src = p_image_url;
            this.image_data = "";
            this.def_location_image_id = p_id;
            this.setState({image_lib_visible:false, def_location_image_id:p_id});
            this.setState({ image_oke:true});
        }
        else {
            this.setState({image_lib_visible: false});
        }
    }

    imageSelected(event) {

        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            console.log("no file")
            return;
        }

        this.deleteImgBtn.current.style.display = 'inline-block';

        var reader = new FileReader();
        const _this = this;
        reader.onload = function (e) {
            _this.imagePreview.current.src = e.target.result;
            _this.image_data = e.target.result;
            _this.imagePreview.current.style.display = 'block';
            _this.delete_image_upload = false;

            // check nu de afmetingen
            let img = document.createElement("img");
            img.src = _this.image_data;
            let width = img.width;
            let  height = img.height;
            if (width > height) {
                if (width > 800) {
                    height *= 800 / width;
                    width = 800;
                }
            } else {
                if (height > 600) {
                    width *= 600/ height;
                    height = 600;
                }
            }

            if (width != 800 || height != 600)
            {
                _this.setState({ image_oke:false});
            }
            else
            {
                _this.setState({ image_oke:true});
            }


            _this.setState({ def_location_image_id:0});
        };
        reader.readAsDataURL(fileObj);
    }


    terugClicked() {
        this.props.finished_callback(false, {});
    }

    storeClicked() {
        if (this.inputTitle.current.value == "") {
            this.setState({"show_err": true, "err_message": "Geen geldig naam ingevoerd. Probeer het opnieuw"});
            return false;
        }


        this.setState({"show_err": false});
        this.formData.append("title", this.inputTitle.current.value);
        // hebben we een afbeelding of moeten we die misschien verwijderen
        if (this.props.action != "add" && this.delete_image_upload)
        {
            this.formData.append("has_image","N")
        }

        if (this.image_data != "")
        {
            var img = document.createElement("img");
            img.src = this.image_data;
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            // Set Width and Height

            var width = img.width;
            var height = img.height;
            if (width > height) {
                if (width > 800) {
                    height *= 800 / width;
                    width = 800;
                }
            } else {
                if (height > 600) {
                    width *= 600/ height;
                    height = 600;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            this.formData.append("image", canvas.toDataURL("image/jpeg", 1)); // 100% kwaliteit
            this.formData.append("has_image","Y");
        }
        else
        {
            if (this.state.def_location_image_id > 0)
            {
                this.formData.append("has_image","Y");
                this.formData.append("def_location_image_id",this.state.def_location_image_id);
            }
        }

        const requestOptions = {
            method: 'POST',
            body: this.formData
        };

        fetch(this.form_url, requestOptions)
            .then(response => response.json())
            .then(location_json => {
                if (location_json.status == "err") {
                    this.setState({"show_err": true, "err_message": "Opslaan niet gelukt. Probeer het opnieuw"});

                } else {
                    this.setState({'show_err': false});
                    this.props.finished_callback(true, location_json.data.location);
                }
            });
    }

    render() {
        return (
            <FormPopup close_btn={false} title={this.props.action == "add" ? "Hoek toevoegen":"Hoek aanpassen"}>
                <h2>Naam van de hoek</h2>
                <input type={"text"} className={"tool__content__login__input"} name={"title"} style={{"width": "35vw"}}
                       ref={this.inputTitle} defaultValue={this.props.record.title} autoFocus/><br/>
                <h2>Afbeelding (verhouding 4:3, bijvoorbeeld 800 x 600 pixels)</h2>

                <input type="file" accept="image/*;capture=camera" id="upload_image" name={"image"}
                       ref={this.inputImageBtn}
                       style={{"display": "none"}} onChange={this.imageSelected}
                />

                { (this.props.action == "add" || this.props.record.has_image == "N") && (
                <img id="upload_image_preview"
                     style={{"width": "20%", "height": "auto", "margin-top": "5px", "display": " none"}}
                     ref={this.imagePreview}/>
                )}
                { ( this.props.record.has_image == "Y") && (
                    <img id="upload_image_preview" src={this.props.record.image_url}
                         style={{"width": "20%", "height": "auto", "margin-top": "5px"}}
                         ref={this.imagePreview}/>
                )}
                { !this.state.image_oke &&
                    (<p style={{"color": "#F00"}}>De afbeelding heeft niet de verhouding 4:3, wordt verkleind.</p>)
                }


                <br clear="all"/>
                <a href="javascript:void(0);" onClick={this.imageSelectClicked} className={"button"}
                   id="upload_image_btn">Upload eigen afbeelding</a>
                <a href="javascript:void(0);" onClick={this.showImageLibClicked} className={"button"}
                   id="upload_image_btn">Kies afbeelding uit bibliotheek</a>
                <a href="javascript:void(0);" onClick={this.imageDeleteClicked} className={"button"}
                   id="delete_image_btn" style={{"display": (this.props.action == "add" || this.props.record.has_image == "N") ? "none": "inline-block"}} ref={this.deleteImgBtn}>Verwijder afbeelding</a>


                <br/><br/>
                <a href="javascript:void(0)" className={"button"} onClick={this.terugClicked}>Terug</a>
                <a href="javascript:void(0)" className={"button"} onClick={this.storeClicked}>Opslaan</a>


                {this.state.show_err && (
                    <div style={{"float": "left", "width": "100%", "color": "#F00"}}>
                        <p>{this.state.err_message}</p>
                    </div>
                )}


                {this.state.image_lib_visible &&
                    (
                            <LocationLibSelector callback={this.selectImageLib} current_id={this.state.def_location_image_id} />
                    )
                }
            </FormPopup>

        );
    }

}
